module.exports = __webpack_public_path__ + "img/cju_thumbnail.86486b07.jpg";